import { eLogType } from "@models";
import { icons } from "@tools";
import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.LogIconFilter,
    dependencies: [
    ]
})
export class LogIconFilter {
    constructor() {
        return ((type: string) => {
            switch (type) {
                case eLogType.error:
                    return icons.error;
                case eLogType.info:
                    return icons.info;
                default:
                    return icons.success;
            }
        }) as any;
    }
}
